import React, { useEffect, useState } from 'react'
import Options from './Options'
import loader from '../../../../assets/img/loader.svg'
import { Link } from 'react-router-dom'
import notFound from '../../../../assets/img/not-found.png'
import Skeleton from 'react-loading-skeleton'
import Api from '../../../../_helpers/Api'
import checkIcon from '../../../../assets/img/icons/check.png'
import ReactTooltip from 'react-tooltip'
import { trans } from '../../../../_providers/Translation'
import { Tooltip } from '@mui/material'
import moment from 'moment'

function TableAppliances(props) {

    const handlePrint = id => {
        let img = document.querySelector('img[data-for="' + id + '"]')

        if (img) {
            let src = img.getAttribute('src')

            let w = window.open('', '_blank')

            w.document.write('<img src="' + src + '" />')
            w.document.close()

            w.focus()
            w.print()
        }
    }

    return (

        props.parts.length === 0
            ?
            <div className="not-found">
                <img src={notFound} alt="Not Found" />
                <p>
                    {trans('messages.noResultsFound')}.
                </p>
            </div>
            :
            <>
                <div className="table-scroller">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>{trans('tables.brand')}</th>
                                <th>{trans('tables.model')}</th>
                                <th>{trans('tables.category')}</th>
                                <th>{trans('tables.date')}</th>
                                <th className="right">{trans('tables.price')}</th>
                                <th className="center">
                                    {trans('tables.qrCode')}
                                </th>
                                <th>{trans('tables.status')}</th>
                                <th className="options">{trans('tables.options')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.parts.map(p =>
                                <tr key={'p-' + p.id}>
                                    <td>
                                        {p.part.id}
                                    </td>

                                    <td>
                                        {p.part?.brand}
                                    </td>
                                    <td>
                                        {p.part?.model}
                                    </td>
                                    <td>
                                        {p.part.category
                                            ?
                                            p.part.category.name
                                            :
                                            ''
                                        }
                                    </td>
                                    <td>
                                        {moment(p.part?.created_at).format('DD.MM.YYYY')}
                                    </td>
                                    <td className="right">
                                        {`${(p.part?.sell_price || 0).toFixed(2)} ${p.part?.currency || 'EUR'}`}
                                    </td>
                                    <td className="center">
                                        <img src={p.part?.qrcode_url} data-tip data-for={'qr-' + p.part?.id} alt="" height={25} />
                                        <ReactTooltip
                                            id={'qr-' + p.part?.id}
                                            effect="solid"
                                            border={true}
                                            borderColor="#ccc"
                                            backgroundColor="white"
                                            arrowColor="white"
                                            className="clickable-tooltip"
                                            delayShow={300}
                                            delayHide={500}
                                            clickable
                                            isCapture
                                            globalEventOff="click"
                                        >

                                            <img src={p.part?.qrcode_url} alt="" style={{ maxWidth: '300px', maxHeight: '300px' }} />
                                            <button className="button-small" style={{ width: '100%' }} onClick={e => handlePrint('qr-' + p.part?.id)}>
                                                {trans('buttons.print')}
                                            </button>
                                        </ReactTooltip>
                                    </td>
                                    <td>
                                        {Number(p.quantity) ?
                                            <Tooltip title={`${p.quantity} ${trans('random.countShort')}`} followCursor>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <span style={{
                                                        backgroundColor: '#35B084',
                                                        width: '11px',
                                                        height: '22px',
                                                        borderRadius: '8px',
                                                        display: 'block',
                                                    }}>

                                                    </span>
                                                    {trans('random.inStockSec')}
                                                </div>
                                            </Tooltip>
                                            :
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <span style={{
                                                    backgroundColor: '#EC5252',
                                                    width: '11px',
                                                    height: '22px',
                                                    borderRadius: '8px',
                                                    display: 'block',
                                                }}>

                                                </span>
                                                {trans('random.noStock')}
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        <Options
                                            id={p.part.id}
                                            deletable={p.deletable}
                                            editable={p.editable}
                                            transferable={p.transferable}
                                            canAcceptTransfer={p.can_accept_transfer}
                                            handleEdit={props.handleEdit}
                                            handleDelete={props.handleDelete}
                                            handleTransfer={props.handleTransfer}
                                            handleHistory={props.handleHistory}
                                            handleAddInStorage={props.handleAddInStorage}
                                            handleCorrect={props.handleCorrect}
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>


            </>
    )
}

export default TableAppliances